function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.89 13.51A7.362 7.362 0 117.837 0a7.362 7.362 0 015.494 12.264l4.556 4.557a.95.95 0 01-1.343 1.343l-4.654-4.653zm-4.053-.685A5.462 5.462 0 107.838 1.9a5.462 5.462 0 000 10.925z",
  fill: "#B6B6B6",
  fillRule: "evenodd"
});

function SvgSearchAbu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSearchAbu;